// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3193b","questions":"styles_questions__3wh0K","footer":"styles_footer__25WiG"};